import { GroupuiButton, GroupuiGridCol, GroupuiGridRow, GroupuiHeadline } from '@sdc-wob-type-3/group-ui-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoggedoutIcon from '../../assets/LoggedoutIcon';
import environment from '../../environment';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import './LoggedoutPage.css';

export const LOGGED_OUT_PATH = '/loggedout';

export function LoggedoutPage() {
  const { t } = useTranslation();

  const login = () => {
    window.location.href = `${environment.PRIVATE_UI_URL}`;
  };

  return (
    <div id="loggedout-container">
      <GroupuiGridRow type="fixed">
        <GroupuiGridCol s="12" m="12" l="12" xl="12" xxl="12">
          <Header />
        </GroupuiGridCol>
      </GroupuiGridRow>
      <LoggedoutIcon id="loggedout-image" />
      <GroupuiHeadline id="loggedout-headline" heading="h2" weight="bold" serif={false}>
        {t('page.loggedout.header')}
      </GroupuiHeadline>

      <div id="loggedout-buttons-container">
        <GroupuiButton id="loggedout-login-button" size="m" variant="secondary" inverted={true} onClick={login}>
          {t('page.loggedout.login')}
        </GroupuiButton>
      </div>
      <Footer />
    </div>
  );
}
